import script from "./ConsentList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentList.vue?vue&type=script&setup=true&lang=js"

import "./ConsentList.vue?vue&type=style&index=0&id=673d756c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673d756c"]])

export default __exports__